/**
 * @flow
 * @relayHash 0840ef1a684c795958e24a63ea611ae6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AddUpdateJobModal_job$ref = any;
type CloseJobModal_job$ref = any;
type DeleteJobModal_job$ref = any;
type JobDetails_defaultForm$ref = any;
type JobDetails_job$ref = any;
type JobLinkedItems_job$ref = any;
type JobSubComponents_job$ref = any;
type ReopenJobModal_job$ref = any;
type Runs_job$ref = any;
type UserWidget_user$ref = any;
export type JobStatus = "CLOSED" | "OPEN";
export type Permission = "CREATE_API_KEY" | "CREATE_CUSTOMER" | "CREATE_INVOICE" | "CREATE_ITEM" | "CREATE_JOB" | "CREATE_LOT" | "CREATE_ORDER" | "CREATE_PAYMENT" | "CREATE_SHIPMENT" | "DELETE_API_KEY" | "DELETE_CUSTOMER" | "DELETE_INVOICE" | "DELETE_ITEM" | "DELETE_JOB" | "DELETE_LOT" | "DELETE_ORDER" | "DELETE_SHIPMENT" | "READ_API_KEY" | "READ_CUSTOMER" | "READ_INVOICE" | "READ_ITEM" | "READ_JOB" | "READ_LOT" | "READ_ORDER" | "READ_PAYMENT" | "READ_SHIPMENT" | "UPDATE_API_KEY" | "UPDATE_CUSTOMER" | "UPDATE_INVOICE" | "UPDATE_ITEM" | "UPDATE_JOB" | "UPDATE_LOT" | "UPDATE_ORDER" | "UPDATE_SHIPMENT";
export type JobQueryVariables = {|
  id: string
|};
export type JobQueryResponse = {|
  +job: {|
    +id: string,
    +jobNumber: string,
    +importJobNumber: ?string,
    +importPreviousJobNumber: ?string,
    +status: JobStatus,
    +name: string,
    +notes: ?string,
    +forceClosedAt: ?any,
    +createdAt: any,
    +importAttachment: ?{|
      +id: string,
      +urlPath: string,
    |},
    +user: ?{|
      +$fragmentRefs: UserWidget_user$ref
    |},
    +order: ?{|
      +id: string,
      +orderNumber: string,
      +customerOrderNumber: ?string,
      +requiredAt: ?any,
      +promisedAt: ?any,
      +shippingAddressLine1: ?string,
      +shippingAddressLine2: ?string,
      +shippingAddressLine3: ?string,
      +shippingAddressCity: ?string,
      +shippingAddressState: ?string,
      +shippingAddressZip: ?string,
      +customer: {|
        +id: string,
        +name: string,
      |},
    |},
    +workflow: {|
      +id: string,
      +name: string,
    |},
    +yields: {|
      +edges: ?$ReadOnlyArray<?{|
        +node: {|
          +id: string,
          +quantity: number,
          +finalQuantity: number,
          +item: {|
            +id: string,
            +name: string,
            +itemNumber: string,
            +description: ?string,
          |},
        |}
      |}>
    |},
    +$fragmentRefs: JobDetails_job$ref & Runs_job$ref & AddUpdateJobModal_job$ref & CloseJobModal_job$ref & ReopenJobModal_job$ref & DeleteJobModal_job$ref & JobLinkedItems_job$ref & JobSubComponents_job$ref,
  |},
  +forms: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +$fragmentRefs: JobDetails_defaultForm$ref,
      |}
    |}>
  |},
  +viewer: ?{|
    +id: string,
    +permissions: $ReadOnlyArray<Permission>,
    +company: {|
      +id: string,
      +name: ?string,
      +addressLine1: ?string,
      +addressLine2: ?string,
      +addressCity: ?string,
      +addressState: ?string,
      +addressZip: ?string,
      +addressCountry: ?string,
      +phone: ?string,
    |},
  |},
|};
export type JobQuery = {|
  variables: JobQueryVariables,
  response: JobQueryResponse,
|};
*/


/*
query JobQuery(
  $id: ID!
) {
  job(id: $id) {
    id
    jobNumber
    importJobNumber
    importPreviousJobNumber
    status
    name
    notes
    forceClosedAt
    createdAt
    importAttachment {
      id
      urlPath
    }
    user {
      ...UserWidget_user
      id
    }
    order {
      id
      orderNumber
      customerOrderNumber
      requiredAt
      promisedAt
      shippingAddressLine1
      shippingAddressLine2
      shippingAddressLine3
      shippingAddressCity
      shippingAddressState
      shippingAddressZip
      customer {
        id
        name
      }
    }
    workflow {
      id
      name
    }
    yields {
      edges {
        node {
          id
          quantity
          finalQuantity
          item {
            id
            name
            itemNumber
            description
          }
        }
      }
    }
    ...JobDetails_job
    ...Runs_job
    ...AddUpdateJobModal_job
    ...CloseJobModal_job
    ...ReopenJobModal_job
    ...DeleteJobModal_job
    ...JobLinkedItems_job
    ...JobSubComponents_job
  }
  forms(types: [ITEM]) {
    edges {
      node {
        id
        ...JobDetails_defaultForm
      }
    }
  }
  viewer {
    id
    permissions
    company {
      id
      name
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
      addressCountry
      phone
    }
  }
}

fragment UserWidget_user on User {
  id
  firstName
  lastName
  ...UserAvatar_user
}

fragment JobDetails_job on Job {
  id
  status
  ...AddUpdateJobYieldModal_job
  ...WorkflowDiagram_job
  ...UpdateJobStateModal_job
  workflow {
    id
    states {
      id
      name
      isRequired
      type
      isGangRun
    }
    transitions {
      id
      toWorkflowState {
        id
      }
      fromWorkflowState {
        id
      }
    }
  }
  states {
    id
    isEnabled
    status
    workflowState {
      id
      name
      type
      isAssignable
      form {
        id
      }
    }
    ...JobStateGrid_jobState
    ...UpdateJobStateModal_jobState
  }
  yields {
    edges {
      ...JobYieldPanels_jobYieldEdges
      cursor
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  order {
    id
    orderNumber
  }
}

fragment Runs_job on Job {
  id
  jobNumber
  status
  workflow {
    id
    isParallelWorkflow
  }
  runs {
    edges {
      ...RunPanels_runEdges
      cursor
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...AddUpdateRunModal_job
  ...AutoScheduleJobModal_job
  ...RunYieldProgressBarPanels_job
}

fragment AddUpdateJobModal_job on Job {
  id
  name
  notes
  user {
    id
  }
  workflow {
    id
    name
    states {
      id
      isGangRun
    }
  }
  order {
    id
  }
  yields {
    edges {
      node {
        id
        quantity
        itemNumberUp
        brokerCustomerOrderNumber
        formFieldValues
        overUnderRule
        overQuantity
        item {
          id
          name
          quantityUOM {
            id
            name
            symbol
          }
        }
      }
    }
  }
}

fragment CloseJobModal_job on Job {
  id
  yields {
    edges {
      node {
        id
        quantity
        finalQuantity
        item {
          id
          name
          quantityUOM {
            id
            symbol
          }
          lotTracking
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReopenJobModal_job on Job {
  id
  yields {
    edges {
      node {
        id
        finalQuantity
        item {
          id
          lotTracking
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment DeleteJobModal_job on Job {
  id
  name
  order {
    id
  }
}

fragment JobLinkedItems_job on Job {
  id
  ...AddJobLinkedItemModal_job
  ...AddUpdateJobLinkedItemModal_job
  linkedItems {
    edges {
      ...JobLinkedItemsTable_jobLinkedItemEdges
      node {
        id
        name
        partNumber
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment JobSubComponents_job on Job {
  id
  ...AddUpdateJobSubComponentModal_job
  subComponents {
    edges {
      ...JobSubComponentsTree_jobSubComponentEdges
      usageQty
      node {
        id
        name
        partNumber
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  yields {
    edges {
      ...JobSubComponentsTree_jobYieldEdges
      cursor
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment JobDetails_defaultForm on Form {
  id
  ...AddUpdateItemModal_defaultForm
}

fragment AddUpdateItemModal_defaultForm on Form {
  id
  type
  name
  systemKey
  productionType {
    id
  }
  fields {
    id
    systemKey
    type
    name
    description
    placeholder
    isRequired
    isCreatable
    applicationType
    displayOrder
    properties
    options {
      name
      value
      id
    }
  }
}

fragment AddUpdateJobSubComponentModal_job on Job {
  id
  subComponents {
    edges {
      usageQty
      node {
        id
        name
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment JobSubComponentsTree_jobSubComponentEdges on JobSubComponentEdge {
  usageQty
  node {
    id
    itemNumber
    name
    partNumber
    upc
    description
    category {
      id
      name
    }
    totalQty
    quantityUOM {
      id
      symbol
    }
    lotTracking
    childItems {
      edges {
        usageQty
        node {
          id
          itemNumber
          name
          partNumber
          upc
          totalQty
          quantityUOM {
            id
            symbol
          }
          category {
            id
            name
          }
          lotTracking
        }
      }
    }
    ...DeleteJobSubComponentModal_item
  }
}

fragment JobSubComponentsTree_jobYieldEdges on JobYieldEdge {
  node {
    id
    quantity
    item {
      id
      itemNumber
      name
      partNumber
      upc
      totalQty
      quantityUOM {
        id
        symbol
      }
      category {
        id
        name
      }
      lotTracking
      childItems {
        edges {
          usageQty
          node {
            id
            itemNumber
            name
            partNumber
            upc
            totalQty
            quantityUOM {
              id
              symbol
            }
            category {
              id
              name
            }
            lotTracking
          }
        }
      }
    }
  }
}

fragment DeleteJobSubComponentModal_item on Item {
  id
  name
}

fragment AddJobLinkedItemModal_job on Job {
  id
}

fragment AddUpdateJobLinkedItemModal_job on Job {
  id
  linkedItems {
    edges {
      usageQty
      node {
        id
        name
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment JobLinkedItemsTable_jobLinkedItemEdges on JobLinkedItemEdge {
  usageQty
  node {
    id
    itemNumber
    name
    partNumber
    description
    category {
      id
      name
    }
    quantityUOM {
      id
      symbol
    }
    ...DeleteJobLinkedItemModal_item
  }
}

fragment DeleteJobLinkedItemModal_item on Item {
  id
  name
}

fragment RunPanels_runEdges on RunEdge {
  node {
    id
    status
    scheduledStartAt
    jobState {
      id
      workflowState {
        id
        name
      }
    }
    machine {
      id
      name
    }
    yields {
      edges {
        ...RunYieldsList_runYieldEdges
        cursor
        node {
          __typename
          id
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    job {
      id
      ...AddUpdateRunModal_job
    }
    ...AddUpdateRunModal_run
    ...DeleteRunModal_run
    ...ViewRunModal_run
  }
}

fragment AddUpdateRunModal_job on Job {
  id
  states {
    id
    isEnabled
    workflowState {
      id
      name
      machineType {
        id
      }
    }
  }
  yields {
    edges {
      node {
        id
        item {
          id
          name
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AutoScheduleJobModal_job on Job {
  id
  workflow {
    id
    states {
      id
      type
      name
    }
    transitions {
      toWorkflowState {
        id
      }
      fromWorkflowState {
        id
      }
      id
    }
  }
  states {
    id
    isEnabled
    workflowState {
      id
      name
      type
      machineType {
        id
      }
    }
  }
  yields {
    edges {
      node {
        id
        item {
          id
          name
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment RunYieldProgressBarPanels_job on Job {
  id
  workflow {
    id
    states {
      id
      name
      isRequired
      type
    }
    transitions {
      id
      toWorkflowState {
        id
      }
      fromWorkflowState {
        id
      }
    }
  }
  states {
    id
    isEnabled
    status
    workflowState {
      id
      name
      type
    }
  }
  runs {
    edges {
      node {
        id
        runTotalSeconds
        jobState {
          id
          workflowState {
            id
            isGangRun
            name
          }
        }
        yields {
          edges {
            runQuantity
            node {
              id
              ...YieldProgressBar_jobYield
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment YieldProgressBar_jobYield on JobYield {
  id
  itemNumberUp
  quantity
  finalQuantity
  overUnderRule
  overQuantity
  item {
    id
    name
    quantityUOM {
      id
      symbol
    }
  }
}

fragment RunYieldsList_runYieldEdges on RunYieldEdge {
  totalItemQuantity
  node {
    id
    item {
      id
      name
      quantityUOM {
        id
        symbol
      }
    }
  }
}

fragment AddUpdateRunModal_run on Run {
  id
  scheduledStartAt
  notes
  machine {
    id
    name
    type {
      id
    }
  }
  jobState {
    id
  }
  yields {
    edges {
      node {
        id
        item {
          id
          name
        }
      }
    }
  }
}

fragment DeleteRunModal_run on Run {
  id
  machine {
    id
    name
    type {
      id
      name
    }
  }
}

fragment ViewRunModal_run on Run {
  id
  status
  notes
  scheduledStartAt
  scheduledEndAt
  actualStartAt
  actualEndAt
  jobState {
    id
    workflowState {
      id
      name
    }
  }
  machine {
    id
    name
    type {
      id
      name
    }
  }
  ...RunLogs_run
  ...RunYields_run
}

fragment RunLogs_run on Run {
  id
  yields {
    edges {
      setupQuantity
      runQuantity
      defectQuantity
      node {
        id
        item {
          id
          name
        }
      }
    }
  }
  machine {
    id
  }
  logs {
    id
    type
    notes
    createdAt
    user {
      ...UserWidget_user
      id
    }
  }
}

fragment RunYields_run on Run {
  id
  yields {
    edges {
      defectQuantity
      setupQuantity
      runQuantity
      node {
        id
        item {
          id
          name
          quantityUOM {
            id
            symbol
          }
        }
      }
    }
  }
}

fragment AddUpdateJobYieldModal_job on Job {
  id
  order {
    id
    orderNumber
  }
  workflow {
    id
    states {
      id
      isGangRun
    }
  }
}

fragment WorkflowDiagram_job on Job {
  id
  states {
    id
    status
    user {
      id
      firstName
      lastName
    }
    runs {
      id
      status
    }
    workflowState {
      id
      type
      name
      isRequired
      runMinutesOverride
      form {
        id
        name
      }
    }
    isEnabled
    updatedAt
    createdAt
  }
  workflow {
    id
    transitions {
      id
      toWorkflowState {
        id
      }
      fromWorkflowState {
        id
      }
    }
  }
}

fragment UpdateJobStateModal_job on Job {
  id
  status
  workflow {
    id
    states {
      id
      name
      isRequired
      type
    }
    transitions {
      id
      toWorkflowState {
        id
      }
      fromWorkflowState {
        id
      }
    }
  }
  states {
    id
    isEnabled
    status
    workflowState {
      id
      name
      type
    }
  }
}

fragment JobStateGrid_jobState on JobState {
  id
  formFieldValues
  isEnabled
  status
  user {
    id
    ...UserWidget_user
  }
  workflowState {
    id
    name
    isAssignable
    type
    form {
      id
      fields {
        id
        name
        type
        ...CosmeticFieldValue_formField
        ...AdditionalFieldInfo_formField
      }
    }
  }
}

fragment UpdateJobStateModal_jobState on JobState {
  id
  formFieldValues
  status
  workflowState {
    id
    name
    isAssignable
    type
    machineType {
      id
    }
    defaultUser {
      id
    }
    form {
      id
      name
      type
      systemKey
      productionType {
        id
      }
      fields {
        id
        systemKey
        type
        name
        description
        placeholder
        isRequired
        isCreatable
        applicationType
        displayOrder
        properties
        options {
          name
          value
          id
        }
        ...AdditionalFieldInfo_formField
      }
    }
  }
  user {
    id
  }
}

fragment JobYieldPanels_jobYieldEdges on JobYieldEdge {
  node {
    id
    quantity
    itemNumberUp
    brokerCustomerOrderNumber
    formFieldValues
    form {
      id
      ...FormBuilder_form
      fields {
        id
        systemKey
        name
        type
      }
    }
    item {
      id
      itemNumber
      name
      description
      partNumber
      formFieldValues
      quantityUOM {
        id
        symbol
      }
      form {
        id
        ...FormBuilder_form
        fields {
          id
          systemKey
          name
          type
        }
      }
    }
    ...AddUpdateJobYieldModal_jobYield
    ...DeleteJobYieldModal_jobYield
    ...YieldProgressBar_jobYield
  }
}

fragment FormBuilder_form on Form {
  id
  name
  type
  systemKey
  productionType {
    id
  }
  fields {
    id
    systemKey
    type
    name
    description
    placeholder
    isRequired
    isCreatable
    applicationType
    displayOrder
    properties
    options {
      name
      value
      id
    }
  }
}

fragment AddUpdateJobYieldModal_jobYield on JobYield {
  id
  quantity
  itemNumberUp
  brokerCustomerOrderNumber
  formFieldValues
  overUnderRule
  overQuantity
  item {
    id
    quantityUOM {
      id
      name
      symbol
    }
  }
  form {
    id
    name
    type
    systemKey
    productionType {
      id
    }
    fields {
      id
      systemKey
      type
      name
      description
      placeholder
      isRequired
      isCreatable
      applicationType
      displayOrder
      properties
      options {
        name
        value
        id
      }
    }
  }
}

fragment DeleteJobYieldModal_jobYield on JobYield {
  id
  item {
    id
    name
  }
}

fragment AdditionalFieldInfo_formField on FormField {
  id
  name
  type
}

fragment CosmeticFieldValue_formField on FormField {
  id
  name
  type
}

fragment UserAvatar_user on User {
  id
  avatar
  firstName
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "jobNumber",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "importJobNumber",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "importPreviousJobNumber",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "forceClosedAt",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "importAttachment",
  "storageKey": null,
  "args": null,
  "concreteType": "Attachment",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "urlPath",
      "args": null,
      "storageKey": null
    }
  ]
},
v12 = [
  (v2/*: any*/),
  (v7/*: any*/)
],
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "order",
  "storageKey": null,
  "args": null,
  "concreteType": "Order",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "orderNumber",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "customerOrderNumber",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "requiredAt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "promisedAt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shippingAddressLine1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shippingAddressLine2",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shippingAddressLine3",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shippingAddressCity",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shippingAddressState",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shippingAddressZip",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "customer",
      "storageKey": null,
      "args": null,
      "concreteType": "Customer",
      "plural": false,
      "selections": (v12/*: any*/)
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "finalQuantity",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "itemNumber",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "types",
    "value": [
      "ITEM"
    ]
  }
],
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "viewer",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "permissions",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "company",
      "storageKey": null,
      "args": null,
      "concreteType": "Company",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v7/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "addressLine1",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "addressLine2",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "addressCity",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "addressState",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "addressZip",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "addressCountry",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "phone",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "user",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "lastName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "avatar",
      "args": null,
      "storageKey": null
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isGangRun",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isRequired",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v24 = [
  (v2/*: any*/)
],
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "partNumber",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "formFieldValues",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "systemKey",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "productionType",
  "storageKey": null,
  "args": null,
  "concreteType": "ProductionType",
  "plural": false,
  "selections": (v24/*: any*/)
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "placeholder",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isCreatable",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "applicationType",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayOrder",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "properties",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "options",
  "storageKey": null,
  "args": null,
  "concreteType": "FormFieldOption",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "value",
      "args": null,
      "storageKey": null
    },
    (v2/*: any*/)
  ]
},
v36 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "fields",
  "storageKey": null,
  "args": null,
  "concreteType": "FormField",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v28/*: any*/),
    (v23/*: any*/),
    (v7/*: any*/),
    (v17/*: any*/),
    (v30/*: any*/),
    (v22/*: any*/),
    (v31/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/)
  ]
},
v37 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "form",
  "storageKey": null,
  "args": null,
  "concreteType": "Form",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v7/*: any*/),
    (v23/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v36/*: any*/)
  ]
},
v38 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lotTracking",
  "args": null,
  "storageKey": null
},
v39 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "upc",
  "args": null,
  "storageKey": null
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalQty",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemCategory",
  "plural": false,
  "selections": (v12/*: any*/)
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "usageQty",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "quantityUOM",
  "storageKey": null,
  "args": null,
  "concreteType": "UOM",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v27/*: any*/)
  ]
},
v44 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "childItems",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemChildConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemChildEdge",
      "plural": true,
      "selections": [
        (v42/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v16/*: any*/),
            (v7/*: any*/),
            (v25/*: any*/),
            (v39/*: any*/),
            (v40/*: any*/),
            (v43/*: any*/),
            (v41/*: any*/),
            (v38/*: any*/)
          ]
        }
      ]
    }
  ]
},
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "itemNumberUp",
  "args": null,
  "storageKey": null
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "overUnderRule",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "overQuantity",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v50 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v51 = {
  "kind": "LinkedHandle",
  "alias": null,
  "name": "yields",
  "args": null,
  "handle": "connection",
  "key": "AddUpdateRunModal_job_yields",
  "filters": ([]/*: any*/)
},
v52 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "machineType",
  "storageKey": null,
  "args": null,
  "concreteType": "MachineType",
  "plural": false,
  "selections": (v24/*: any*/)
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isEnabled",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "JobQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "job",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Job",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "UserWidget_user",
                "args": null
              }
            ]
          },
          (v13/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "workflow",
            "storageKey": null,
            "args": null,
            "concreteType": "Workflow",
            "plural": false,
            "selections": (v12/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "yields",
            "storageKey": null,
            "args": null,
            "concreteType": "JobYieldConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "JobYieldEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobYield",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v7/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "JobDetails_job",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "Runs_job",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "AddUpdateJobModal_job",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "CloseJobModal_job",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "ReopenJobModal_job",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "DeleteJobModal_job",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "JobLinkedItems_job",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "JobSubComponents_job",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "forms",
        "storageKey": "forms(types:[\"ITEM\"])",
        "args": (v18/*: any*/),
        "concreteType": "FormConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "FormEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Form",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "JobDetails_defaultForm",
                    "args": null
                  }
                ]
              }
            ]
          }
        ]
      },
      (v19/*: any*/)
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "JobQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "job",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Job",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v20/*: any*/),
          (v13/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "workflow",
            "storageKey": null,
            "args": null,
            "concreteType": "Workflow",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "states",
                "storageKey": null,
                "args": null,
                "concreteType": "WorkflowState",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v21/*: any*/),
                  (v7/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "transitions",
                "storageKey": null,
                "args": null,
                "concreteType": "WorkflowTransition",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "toWorkflowState",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorkflowState",
                    "plural": false,
                    "selections": (v24/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "fromWorkflowState",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorkflowState",
                    "plural": false,
                    "selections": (v24/*: any*/)
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isParallelWorkflow",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "yields",
            "storageKey": null,
            "args": null,
            "concreteType": "JobYieldConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "JobYieldEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobYield",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v7/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "quantityUOM",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UOM",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v27/*: any*/),
                              (v7/*: any*/)
                            ]
                          },
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v44/*: any*/)
                        ]
                      },
                      (v45/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "brokerCustomerOrderNumber",
                        "args": null,
                        "storageKey": null
                      },
                      (v26/*: any*/),
                      (v37/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/)
                    ]
                  },
                  (v49/*: any*/)
                ]
              },
              (v50/*: any*/)
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "yields",
            "args": null,
            "handle": "connection",
            "key": "JobDetails_job_yields",
            "filters": []
          },
          (v51/*: any*/),
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "yields",
            "args": null,
            "handle": "connection",
            "key": "AutoScheduleJobModal_job_yields",
            "filters": []
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "yields",
            "args": null,
            "handle": "connection",
            "key": "CloseJobModal_job_yields",
            "filters": []
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "yields",
            "args": null,
            "handle": "connection",
            "key": "ReopenJobModal_job_yields",
            "filters": []
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "yields",
            "args": null,
            "handle": "connection",
            "key": "JobSubComponents_job_yields",
            "filters": []
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "states",
            "storageKey": null,
            "args": null,
            "concreteType": "JobState",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/),
              (v20/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "runs",
                "storageKey": null,
                "args": null,
                "concreteType": "Run",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workflowState",
                "storageKey": null,
                "args": null,
                "concreteType": "WorkflowState",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v23/*: any*/),
                  (v7/*: any*/),
                  (v22/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "runMinutesOverride",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "form",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Form",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "fields",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FormField",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v7/*: any*/),
                          (v23/*: any*/),
                          (v28/*: any*/),
                          (v17/*: any*/),
                          (v30/*: any*/),
                          (v22/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/)
                        ]
                      },
                      (v23/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isAssignable",
                    "args": null,
                    "storageKey": null
                  },
                  (v52/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "defaultUser",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": (v24/*: any*/)
                  }
                ]
              },
              (v53/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              },
              (v10/*: any*/),
              (v26/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "runs",
            "storageKey": null,
            "args": null,
            "concreteType": "RunConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "RunEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Run",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "scheduledStartAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "jobState",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobState",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "workflowState",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WorkflowState",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v7/*: any*/),
                              (v21/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "machine",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Machine",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "type",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MachineType",
                            "plural": false,
                            "selections": (v12/*: any*/)
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "yields",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "RunYieldConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RunYieldEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "totalItemQuantity",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "JobYield",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "item",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v7/*: any*/),
                                      (v43/*: any*/)
                                    ]
                                  },
                                  (v48/*: any*/),
                                  (v45/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v46/*: any*/),
                                  (v47/*: any*/)
                                ]
                              },
                              (v49/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "setupQuantity",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "runQuantity",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "defectQuantity",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          (v50/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "yields",
                        "args": null,
                        "handle": "connection",
                        "key": "Runs_job_yields",
                        "filters": []
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "job",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Job",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "states",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "JobState",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v53/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "workflowState",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "WorkflowState",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v7/*: any*/),
                                  (v52/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "yields",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "JobYieldConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "JobYieldEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "JobYield",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "item",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Item",
                                        "plural": false,
                                        "selections": (v12/*: any*/)
                                      },
                                      (v48/*: any*/)
                                    ]
                                  },
                                  (v49/*: any*/)
                                ]
                              },
                              (v50/*: any*/)
                            ]
                          },
                          (v51/*: any*/)
                        ]
                      },
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "scheduledEndAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "actualStartAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "actualEndAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "logs",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "RunLog",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v23/*: any*/),
                          (v8/*: any*/),
                          (v10/*: any*/),
                          (v20/*: any*/)
                        ]
                      },
                      (v48/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "runTotalSeconds",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v49/*: any*/)
                ]
              },
              (v50/*: any*/)
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "runs",
            "args": null,
            "handle": "connection",
            "key": "Runs_job_runs",
            "filters": []
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "linkedItems",
            "storageKey": null,
            "args": null,
            "concreteType": "JobLinkedItemConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "JobLinkedItemEdge",
                "plural": true,
                "selections": [
                  (v42/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      (v48/*: any*/),
                      (v16/*: any*/),
                      (v25/*: any*/),
                      (v17/*: any*/),
                      (v41/*: any*/),
                      (v43/*: any*/)
                    ]
                  },
                  (v49/*: any*/)
                ]
              },
              (v50/*: any*/)
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "linkedItems",
            "args": null,
            "handle": "connection",
            "key": "Job_linkedItems",
            "filters": []
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "subComponents",
            "storageKey": null,
            "args": null,
            "concreteType": "JobSubComponentConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "JobSubComponentEdge",
                "plural": true,
                "selections": [
                  (v42/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      (v48/*: any*/),
                      (v16/*: any*/),
                      (v25/*: any*/),
                      (v39/*: any*/),
                      (v17/*: any*/),
                      (v41/*: any*/),
                      (v40/*: any*/),
                      (v43/*: any*/),
                      (v38/*: any*/),
                      (v44/*: any*/)
                    ]
                  },
                  (v49/*: any*/)
                ]
              },
              (v50/*: any*/)
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "subComponents",
            "args": null,
            "handle": "connection",
            "key": "JobSubComponents_subComponents",
            "filters": []
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "forms",
        "storageKey": "forms(types:[\"ITEM\"])",
        "args": (v18/*: any*/),
        "concreteType": "FormConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "FormEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Form",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v23/*: any*/),
                  (v7/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v36/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      (v19/*: any*/)
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "JobQuery",
    "id": null,
    "text": "query JobQuery(\n  $id: ID!\n) {\n  job(id: $id) {\n    id\n    jobNumber\n    importJobNumber\n    importPreviousJobNumber\n    status\n    name\n    notes\n    forceClosedAt\n    createdAt\n    importAttachment {\n      id\n      urlPath\n    }\n    user {\n      ...UserWidget_user\n      id\n    }\n    order {\n      id\n      orderNumber\n      customerOrderNumber\n      requiredAt\n      promisedAt\n      shippingAddressLine1\n      shippingAddressLine2\n      shippingAddressLine3\n      shippingAddressCity\n      shippingAddressState\n      shippingAddressZip\n      customer {\n        id\n        name\n      }\n    }\n    workflow {\n      id\n      name\n    }\n    yields {\n      edges {\n        node {\n          id\n          quantity\n          finalQuantity\n          item {\n            id\n            name\n            itemNumber\n            description\n          }\n        }\n      }\n    }\n    ...JobDetails_job\n    ...Runs_job\n    ...AddUpdateJobModal_job\n    ...CloseJobModal_job\n    ...ReopenJobModal_job\n    ...DeleteJobModal_job\n    ...JobLinkedItems_job\n    ...JobSubComponents_job\n  }\n  forms(types: [ITEM]) {\n    edges {\n      node {\n        id\n        ...JobDetails_defaultForm\n      }\n    }\n  }\n  viewer {\n    id\n    permissions\n    company {\n      id\n      name\n      addressLine1\n      addressLine2\n      addressCity\n      addressState\n      addressZip\n      addressCountry\n      phone\n    }\n  }\n}\n\nfragment UserWidget_user on User {\n  id\n  firstName\n  lastName\n  ...UserAvatar_user\n}\n\nfragment JobDetails_job on Job {\n  id\n  status\n  ...AddUpdateJobYieldModal_job\n  ...WorkflowDiagram_job\n  ...UpdateJobStateModal_job\n  workflow {\n    id\n    states {\n      id\n      name\n      isRequired\n      type\n      isGangRun\n    }\n    transitions {\n      id\n      toWorkflowState {\n        id\n      }\n      fromWorkflowState {\n        id\n      }\n    }\n  }\n  states {\n    id\n    isEnabled\n    status\n    workflowState {\n      id\n      name\n      type\n      isAssignable\n      form {\n        id\n      }\n    }\n    ...JobStateGrid_jobState\n    ...UpdateJobStateModal_jobState\n  }\n  yields {\n    edges {\n      ...JobYieldPanels_jobYieldEdges\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  order {\n    id\n    orderNumber\n  }\n}\n\nfragment Runs_job on Job {\n  id\n  jobNumber\n  status\n  workflow {\n    id\n    isParallelWorkflow\n  }\n  runs {\n    edges {\n      ...RunPanels_runEdges\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...AddUpdateRunModal_job\n  ...AutoScheduleJobModal_job\n  ...RunYieldProgressBarPanels_job\n}\n\nfragment AddUpdateJobModal_job on Job {\n  id\n  name\n  notes\n  user {\n    id\n  }\n  workflow {\n    id\n    name\n    states {\n      id\n      isGangRun\n    }\n  }\n  order {\n    id\n  }\n  yields {\n    edges {\n      node {\n        id\n        quantity\n        itemNumberUp\n        brokerCustomerOrderNumber\n        formFieldValues\n        overUnderRule\n        overQuantity\n        item {\n          id\n          name\n          quantityUOM {\n            id\n            name\n            symbol\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment CloseJobModal_job on Job {\n  id\n  yields {\n    edges {\n      node {\n        id\n        quantity\n        finalQuantity\n        item {\n          id\n          name\n          quantityUOM {\n            id\n            symbol\n          }\n          lotTracking\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ReopenJobModal_job on Job {\n  id\n  yields {\n    edges {\n      node {\n        id\n        finalQuantity\n        item {\n          id\n          lotTracking\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DeleteJobModal_job on Job {\n  id\n  name\n  order {\n    id\n  }\n}\n\nfragment JobLinkedItems_job on Job {\n  id\n  ...AddJobLinkedItemModal_job\n  ...AddUpdateJobLinkedItemModal_job\n  linkedItems {\n    edges {\n      ...JobLinkedItemsTable_jobLinkedItemEdges\n      node {\n        id\n        name\n        partNumber\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment JobSubComponents_job on Job {\n  id\n  ...AddUpdateJobSubComponentModal_job\n  subComponents {\n    edges {\n      ...JobSubComponentsTree_jobSubComponentEdges\n      usageQty\n      node {\n        id\n        name\n        partNumber\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  yields {\n    edges {\n      ...JobSubComponentsTree_jobYieldEdges\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment JobDetails_defaultForm on Form {\n  id\n  ...AddUpdateItemModal_defaultForm\n}\n\nfragment AddUpdateItemModal_defaultForm on Form {\n  id\n  type\n  name\n  systemKey\n  productionType {\n    id\n  }\n  fields {\n    id\n    systemKey\n    type\n    name\n    description\n    placeholder\n    isRequired\n    isCreatable\n    applicationType\n    displayOrder\n    properties\n    options {\n      name\n      value\n      id\n    }\n  }\n}\n\nfragment AddUpdateJobSubComponentModal_job on Job {\n  id\n  subComponents {\n    edges {\n      usageQty\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment JobSubComponentsTree_jobSubComponentEdges on JobSubComponentEdge {\n  usageQty\n  node {\n    id\n    itemNumber\n    name\n    partNumber\n    upc\n    description\n    category {\n      id\n      name\n    }\n    totalQty\n    quantityUOM {\n      id\n      symbol\n    }\n    lotTracking\n    childItems {\n      edges {\n        usageQty\n        node {\n          id\n          itemNumber\n          name\n          partNumber\n          upc\n          totalQty\n          quantityUOM {\n            id\n            symbol\n          }\n          category {\n            id\n            name\n          }\n          lotTracking\n        }\n      }\n    }\n    ...DeleteJobSubComponentModal_item\n  }\n}\n\nfragment JobSubComponentsTree_jobYieldEdges on JobYieldEdge {\n  node {\n    id\n    quantity\n    item {\n      id\n      itemNumber\n      name\n      partNumber\n      upc\n      totalQty\n      quantityUOM {\n        id\n        symbol\n      }\n      category {\n        id\n        name\n      }\n      lotTracking\n      childItems {\n        edges {\n          usageQty\n          node {\n            id\n            itemNumber\n            name\n            partNumber\n            upc\n            totalQty\n            quantityUOM {\n              id\n              symbol\n            }\n            category {\n              id\n              name\n            }\n            lotTracking\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DeleteJobSubComponentModal_item on Item {\n  id\n  name\n}\n\nfragment AddJobLinkedItemModal_job on Job {\n  id\n}\n\nfragment AddUpdateJobLinkedItemModal_job on Job {\n  id\n  linkedItems {\n    edges {\n      usageQty\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment JobLinkedItemsTable_jobLinkedItemEdges on JobLinkedItemEdge {\n  usageQty\n  node {\n    id\n    itemNumber\n    name\n    partNumber\n    description\n    category {\n      id\n      name\n    }\n    quantityUOM {\n      id\n      symbol\n    }\n    ...DeleteJobLinkedItemModal_item\n  }\n}\n\nfragment DeleteJobLinkedItemModal_item on Item {\n  id\n  name\n}\n\nfragment RunPanels_runEdges on RunEdge {\n  node {\n    id\n    status\n    scheduledStartAt\n    jobState {\n      id\n      workflowState {\n        id\n        name\n      }\n    }\n    machine {\n      id\n      name\n    }\n    yields {\n      edges {\n        ...RunYieldsList_runYieldEdges\n        cursor\n        node {\n          __typename\n          id\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    job {\n      id\n      ...AddUpdateRunModal_job\n    }\n    ...AddUpdateRunModal_run\n    ...DeleteRunModal_run\n    ...ViewRunModal_run\n  }\n}\n\nfragment AddUpdateRunModal_job on Job {\n  id\n  states {\n    id\n    isEnabled\n    workflowState {\n      id\n      name\n      machineType {\n        id\n      }\n    }\n  }\n  yields {\n    edges {\n      node {\n        id\n        item {\n          id\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AutoScheduleJobModal_job on Job {\n  id\n  workflow {\n    id\n    states {\n      id\n      type\n      name\n    }\n    transitions {\n      toWorkflowState {\n        id\n      }\n      fromWorkflowState {\n        id\n      }\n      id\n    }\n  }\n  states {\n    id\n    isEnabled\n    workflowState {\n      id\n      name\n      type\n      machineType {\n        id\n      }\n    }\n  }\n  yields {\n    edges {\n      node {\n        id\n        item {\n          id\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment RunYieldProgressBarPanels_job on Job {\n  id\n  workflow {\n    id\n    states {\n      id\n      name\n      isRequired\n      type\n    }\n    transitions {\n      id\n      toWorkflowState {\n        id\n      }\n      fromWorkflowState {\n        id\n      }\n    }\n  }\n  states {\n    id\n    isEnabled\n    status\n    workflowState {\n      id\n      name\n      type\n    }\n  }\n  runs {\n    edges {\n      node {\n        id\n        runTotalSeconds\n        jobState {\n          id\n          workflowState {\n            id\n            isGangRun\n            name\n          }\n        }\n        yields {\n          edges {\n            runQuantity\n            node {\n              id\n              ...YieldProgressBar_jobYield\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment YieldProgressBar_jobYield on JobYield {\n  id\n  itemNumberUp\n  quantity\n  finalQuantity\n  overUnderRule\n  overQuantity\n  item {\n    id\n    name\n    quantityUOM {\n      id\n      symbol\n    }\n  }\n}\n\nfragment RunYieldsList_runYieldEdges on RunYieldEdge {\n  totalItemQuantity\n  node {\n    id\n    item {\n      id\n      name\n      quantityUOM {\n        id\n        symbol\n      }\n    }\n  }\n}\n\nfragment AddUpdateRunModal_run on Run {\n  id\n  scheduledStartAt\n  notes\n  machine {\n    id\n    name\n    type {\n      id\n    }\n  }\n  jobState {\n    id\n  }\n  yields {\n    edges {\n      node {\n        id\n        item {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n\nfragment DeleteRunModal_run on Run {\n  id\n  machine {\n    id\n    name\n    type {\n      id\n      name\n    }\n  }\n}\n\nfragment ViewRunModal_run on Run {\n  id\n  status\n  notes\n  scheduledStartAt\n  scheduledEndAt\n  actualStartAt\n  actualEndAt\n  jobState {\n    id\n    workflowState {\n      id\n      name\n    }\n  }\n  machine {\n    id\n    name\n    type {\n      id\n      name\n    }\n  }\n  ...RunLogs_run\n  ...RunYields_run\n}\n\nfragment RunLogs_run on Run {\n  id\n  yields {\n    edges {\n      setupQuantity\n      runQuantity\n      defectQuantity\n      node {\n        id\n        item {\n          id\n          name\n        }\n      }\n    }\n  }\n  machine {\n    id\n  }\n  logs {\n    id\n    type\n    notes\n    createdAt\n    user {\n      ...UserWidget_user\n      id\n    }\n  }\n}\n\nfragment RunYields_run on Run {\n  id\n  yields {\n    edges {\n      defectQuantity\n      setupQuantity\n      runQuantity\n      node {\n        id\n        item {\n          id\n          name\n          quantityUOM {\n            id\n            symbol\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AddUpdateJobYieldModal_job on Job {\n  id\n  order {\n    id\n    orderNumber\n  }\n  workflow {\n    id\n    states {\n      id\n      isGangRun\n    }\n  }\n}\n\nfragment WorkflowDiagram_job on Job {\n  id\n  states {\n    id\n    status\n    user {\n      id\n      firstName\n      lastName\n    }\n    runs {\n      id\n      status\n    }\n    workflowState {\n      id\n      type\n      name\n      isRequired\n      runMinutesOverride\n      form {\n        id\n        name\n      }\n    }\n    isEnabled\n    updatedAt\n    createdAt\n  }\n  workflow {\n    id\n    transitions {\n      id\n      toWorkflowState {\n        id\n      }\n      fromWorkflowState {\n        id\n      }\n    }\n  }\n}\n\nfragment UpdateJobStateModal_job on Job {\n  id\n  status\n  workflow {\n    id\n    states {\n      id\n      name\n      isRequired\n      type\n    }\n    transitions {\n      id\n      toWorkflowState {\n        id\n      }\n      fromWorkflowState {\n        id\n      }\n    }\n  }\n  states {\n    id\n    isEnabled\n    status\n    workflowState {\n      id\n      name\n      type\n    }\n  }\n}\n\nfragment JobStateGrid_jobState on JobState {\n  id\n  formFieldValues\n  isEnabled\n  status\n  user {\n    id\n    ...UserWidget_user\n  }\n  workflowState {\n    id\n    name\n    isAssignable\n    type\n    form {\n      id\n      fields {\n        id\n        name\n        type\n        ...CosmeticFieldValue_formField\n        ...AdditionalFieldInfo_formField\n      }\n    }\n  }\n}\n\nfragment UpdateJobStateModal_jobState on JobState {\n  id\n  formFieldValues\n  status\n  workflowState {\n    id\n    name\n    isAssignable\n    type\n    machineType {\n      id\n    }\n    defaultUser {\n      id\n    }\n    form {\n      id\n      name\n      type\n      systemKey\n      productionType {\n        id\n      }\n      fields {\n        id\n        systemKey\n        type\n        name\n        description\n        placeholder\n        isRequired\n        isCreatable\n        applicationType\n        displayOrder\n        properties\n        options {\n          name\n          value\n          id\n        }\n        ...AdditionalFieldInfo_formField\n      }\n    }\n  }\n  user {\n    id\n  }\n}\n\nfragment JobYieldPanels_jobYieldEdges on JobYieldEdge {\n  node {\n    id\n    quantity\n    itemNumberUp\n    brokerCustomerOrderNumber\n    formFieldValues\n    form {\n      id\n      ...FormBuilder_form\n      fields {\n        id\n        systemKey\n        name\n        type\n      }\n    }\n    item {\n      id\n      itemNumber\n      name\n      description\n      partNumber\n      formFieldValues\n      quantityUOM {\n        id\n        symbol\n      }\n      form {\n        id\n        ...FormBuilder_form\n        fields {\n          id\n          systemKey\n          name\n          type\n        }\n      }\n    }\n    ...AddUpdateJobYieldModal_jobYield\n    ...DeleteJobYieldModal_jobYield\n    ...YieldProgressBar_jobYield\n  }\n}\n\nfragment FormBuilder_form on Form {\n  id\n  name\n  type\n  systemKey\n  productionType {\n    id\n  }\n  fields {\n    id\n    systemKey\n    type\n    name\n    description\n    placeholder\n    isRequired\n    isCreatable\n    applicationType\n    displayOrder\n    properties\n    options {\n      name\n      value\n      id\n    }\n  }\n}\n\nfragment AddUpdateJobYieldModal_jobYield on JobYield {\n  id\n  quantity\n  itemNumberUp\n  brokerCustomerOrderNumber\n  formFieldValues\n  overUnderRule\n  overQuantity\n  item {\n    id\n    quantityUOM {\n      id\n      name\n      symbol\n    }\n  }\n  form {\n    id\n    name\n    type\n    systemKey\n    productionType {\n      id\n    }\n    fields {\n      id\n      systemKey\n      type\n      name\n      description\n      placeholder\n      isRequired\n      isCreatable\n      applicationType\n      displayOrder\n      properties\n      options {\n        name\n        value\n        id\n      }\n    }\n  }\n}\n\nfragment DeleteJobYieldModal_jobYield on JobYield {\n  id\n  item {\n    id\n    name\n  }\n}\n\nfragment AdditionalFieldInfo_formField on FormField {\n  id\n  name\n  type\n}\n\nfragment CosmeticFieldValue_formField on FormField {\n  id\n  name\n  type\n}\n\nfragment UserAvatar_user on User {\n  id\n  avatar\n  firstName\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '403d3f923331f9c023a42bcc85dc797b';
module.exports = node;
